import React from "react";
import ReactDOM from "react-dom/client";
import installSameOriginRewriter from "@/utils/sameOriginRewriter";
import bootVersionCheck from "@/utils/bootVersionCheck";
import "@/index.css";
import App from "@/App";
import OutdatedVersionBanner from "@/components/OutdatedVersionBanner";
import { AuthProvider } from "@/contexts/AuthContext";
import { TrialProvider } from "@/contexts/TrialContext";
import { LobbySocketProvider } from "@/contexts/LobbySocketContext";
import { RoomChatSocketProvider } from "@/contexts/RoomChatSocketContext";
import { PrivateChatSocketProvider } from "@/contexts/PrivateChatSocketContext";
import { LanguageProvider } from "@/contexts/LanguageContext";
import { KingdomTitlesProvider } from "@/components/KingdomTitle";
import "@/styles/KingdomTitle.css";

// Install same-origin URL rewriter BEFORE React renders so every fetch/
// WebSocket call from the app hits the same origin on the custom production
// domain (avoids cross-site cookie blocks in strict/private browsers).
installSameOriginRewriter();

// Boot-time version check — returning users on a stale cached bundle get a
// hard-reload BEFORE React renders, so they never see the old UI after a
// deploy. Auth session/cookies survive the reload. Anti-loop guarded by
// sessionStorage. Graceful no-op if the backend is unreachable at boot.
(async () => {
  const { reloading } = await bootVersionCheck();
  if (reloading) return; // location.reload() already fired — abort boot.

  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <React.StrictMode>
      <LanguageProvider>
        <AuthProvider>
          <TrialProvider>
            <KingdomTitlesProvider>
              <LobbySocketProvider>
                <RoomChatSocketProvider>
                  <PrivateChatSocketProvider>
                    <OutdatedVersionBanner />
                    <App />
                  </PrivateChatSocketProvider>
                </RoomChatSocketProvider>
              </LobbySocketProvider>
            </KingdomTitlesProvider>
          </TrialProvider>
        </AuthProvider>
      </LanguageProvider>
    </React.StrictMode>,
  );
})();

